import React, { Component } from 'react';
import { Transition } from 'react-transition-group';

const duration = 300;

const EXIT = { opacity: 0, height: 0, overflow: 'hidden', transform: 'translateY(-30px)' };

const transitionStyles = {
  exited: EXIT,
  entering: EXIT,
  exiting: EXIT,
  entered: { opacity: 1, overflow: 'visible', transform: 'none' }
};

type Props = {
  className: String,
  in: Boolean,
  children: React.CElement
};

export default class Collapse extends Component {
  props: Props;

  handleRef = ref => (this.holder = ref);

  render() {
    const { in: inProp, children, style = {}, ...rest } = this.props;
    return (
      <Transition
        in={inProp}
        unmountOnExit={false}
        mountOnEnter={false}
        enter
        appear
        exit
        timeout={{
          enter: 100,
          exit: duration
        }}>
        {state => (
          <div
            {...rest}
            style={{
              ...style,
              transition: `all ${duration}ms cubic-bezier(0.4, 0.0, 0.2, 1)`,
              ...transitionStyles[state],
              height: state === 'entered' && this.holder ? this.holder.clientHeight : 0
            }}>
            <div ref={this.handleRef}>{children}</div>
          </div>
        )}
      </Transition>
    );
  }
}
